"use client";
import { motion } from "framer-motion";
import logo from "@/assets/fresh0meat_logo.png";
import { Suspense } from "react";
import LazyImage from "@/components/LazyImage";

const TermsContent = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="min-h-screen bg-card pb-24"
        >
            <div className="container max-w-3xl mx-auto px-6 py-10 space-y-8">
                {/* Logo + Heading */}
                <div className="flex flex-col items-center gap-3 py-4 border-b border-border">
                    <LazyImage src={logo.src} alt="Fresh O Meat Logo" width={200} height={60} className="h-12 w-auto object-contain" />
                    <h1 className="text-3xl font-extrabold text-foreground text-center mt-4">
                        Terms & Conditions
                    </h1>
                    <p className="text-muted-foreground text-sm">Last updated: March 10, 2026</p>
                </div>

                {/* Body */}
                <div className="space-y-6 text-foreground/80 leading-relaxed">
                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">1. Introduction</h2>
                        <p>
                            Welcome to Fresh O Meat. By accessing our website and using our services, you agree to be bound by the following terms and conditions. Please read them carefully.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">2. Use of Service</h2>
                        <p>
                            You agree to use our services only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of Fresh O Meat.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">3. Product Quality & Freshness</h2>
                        <p>
                            We pride ourselves on providing the highest quality fresh meat. All products are processed under strict hygiene standards and delivered in vacuum-sealed packaging to ensure peak freshness.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">4. Delivery Policy</h2>
                        <p>
                            We aim to deliver your orders within the specified time frames. However, delivery times may vary based on location and external factors. We are not responsible for delays beyond our control.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">5. Pricing</h2>
                        <p>
                            All prices are subject to change without notice. We reserve the right to modify or discontinue any product at any time.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">6. Contact Information</h2>
                        <p>
                            If you have any questions about these Terms, please contact us at freshomeatapp@gmail.com.
                        </p>
                    </section>
                </div>
            </div>
        </motion.div>
    );
};

export default function TermsPage() {
    return (
        <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]">
            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>}>
            <TermsContent />
        </Suspense>
    );
}
